// extracted by mini-css-extract-plugin
module.exports = {"formButtons":"EditUserModal_formButtons__1Pe5I","formEdit":"EditUserModal_formEdit__MBgsk"};